import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  audioTextFileId: null,
  audioTextFile: null,
  currentAudio: null, 
  audioFiles: null,
  pages: {},
  error: "",
  currentPage: null,
  currentTime: 0,
  duration: 0,
  initialPagesLoaded: false,
};

const audioPlayerSlice = createSlice({
  name: "audioPlayer",
  initialState: initialState,
  reducers: {
    reset() {
      return initialState;
    },
    setDuration(state, action) {
      state.duration = action.payload;
    },
    setCurrentTime(state, action) {
      state.currentTime = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    initialize(state, action) {
      state.audioTextFileId = action.payload;
      state.currentPage = 0;
    },
    setPage(state, action) {
      state.initialPagesLoaded = true;
      state.pages[action.payload.page] = action.payload;
    },
    setAudioTextFile(state, action) {
      state.audioTextFile = action.payload;
    },
    setCurrentAudio(state, action) {
      state.currentAudio = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    goToNextPage(state) {
      if(state.currentPage !== null) { 
        state.currentPage = state.currentPage + 1;
      }
    },
    goToPrevPage(state) {
      if(state.currentPage !== null) { 
        state.currentPage = state.currentPage - 1;
      }
    },
    setAudioFiles(state, action) {
      state.audioFiles = action.payload;
    }
  },
});

export const audioPlayerActions = audioPlayerSlice.actions;

export default audioPlayerSlice.reducer;
